// extracted by mini-css-extract-plugin
export default {"inner":"BillingInfoCard_inner__0Daip","title":"BillingInfoCard_title__Cn-es","cardValue":"BillingInfoCard_cardValue__oIuGE"};